/**
 * STATUS MAPS
 * ───────────
 * Centralized badge class + icon + label config for every entity status in the app.
 * Import the relevant map in your component — no more hardcoded badge logic per page.
 */
import {
  FiClock, FiCheckCircle, FiXCircle, FiAlertCircle,
  FiLock, FiUnlock, FiRefreshCw, FiLoader,
} from 'react-icons/fi';

/* ── Pledge statuses ──────────────────────────────────────────────────────── */
export const PLEDGE_STATUS = {
  pending:   { cls: 'badge-pending',   icon: FiClock,        label: 'Pending'   },
  partial:   { cls: 'badge-submitted', icon: FiAlertCircle,  label: 'Partial'   },
  completed: { cls: 'badge-approved',  icon: FiCheckCircle,  label: 'Completed' },
  cancelled: { cls: 'badge-rejected',  icon: FiXCircle,      label: 'Cancelled' },
};

/* ── Receipt / Voucher statuses ───────────────────────────────────────────── */
export const DOCUMENT_STATUS = {
  active:    { cls: 'badge-approved',  icon: FiCheckCircle,  label: 'Active'    },
  cancelled: { cls: 'badge-rejected',  icon: FiXCircle,      label: 'Cancelled' },
};

/* ── Membership / request statuses ───────────────────────────────────────── */
export const MEMBERSHIP_STATUS = {
  pending:   { cls: 'badge-pending',   icon: FiClock,        label: 'Pending'  },
  approved:  { cls: 'badge-approved',  icon: FiCheckCircle,  label: 'Approved' },
  rejected:  { cls: 'badge-rejected',  icon: FiXCircle,      label: 'Rejected' },
};

/* ── Derasar subscription statuses ───────────────────────────────────────── */
export const DERASAR_STATUS = {
  pending:  { cls: 'badge-pending',   icon: FiClock,        label: 'Pending'  },
  approved: { cls: 'badge-approved',  icon: FiCheckCircle,  label: 'Approved' },
  expiring: { cls: 'badge-submitted', icon: FiAlertCircle,  label: 'Expiring' },
  expired:  { cls: 'badge-rejected',  icon: FiXCircle,      label: 'Expired'  },
};

/* ── Financial year statuses ──────────────────────────────────────────────── */
export const FY_STATUS = {
  open:   { cls: 'badge-approved',  icon: FiUnlock,      label: 'Open'   },
  closed: { cls: 'badge-rejected',  icon: FiLock,        label: 'Closed' },
};

/* ── Opening balance statuses ─────────────────────────────────────────────── */
export const OB_STATUS = {
  none:      { cls: 'badge-pending',   icon: FiClock,      label: 'Not Started' },
  draft:     { cls: 'badge-submitted', icon: FiLoader,     label: 'Draft'       },
  locked:    { cls: 'badge-approved',  icon: FiCheckCircle,label: 'Locked'      },
  frozen:    { cls: 'badge-admin',     icon: FiLock,       label: 'Frozen'      },
};

/* ── Category statuses ────────────────────────────────────────────────────── */
export const CATEGORY_STATUS = {
  active:      { cls: 'badge-approved', icon: FiCheckCircle, label: 'Active'      },
  deactivated: { cls: 'badge-rejected', icon: FiXCircle,     label: 'Deactivated' },
};

/* ── Utility: resolve a status map entry (with safe fallback) ─────────────── */
export const resolveStatus = (map, status) =>
  map[status] || { cls: 'badge-pending', icon: FiClock, label: status || '—' };
